import React, { FC } from 'react'
import Heading from '../../../atoms/Heading/Heading'
import classNames from 'classnames'
import { motion } from 'framer-motion'
import { getImage } from '../../../../app/utlis/imageConstants'
import DynamicSVG from '../../../atoms/DynamicSvg/DynamicSvg'

interface EnterpriseIdeaProjectProps {
    enterpriseData: any
}

const EnterpriseIdeaProject: FC<EnterpriseIdeaProjectProps> = ({ enterpriseData }) => {
    const headingVariants = {
        hidden: { opacity: 0, y: 0 },
        visible: { opacity: 1, y: 10, transition: { duration: 0.4 } }
    }

    const projectCardVariants = {
        hidden: { opacity: 0, y: 50 },
        visible: (i: number) => ({
            opacity: 1,
            y: 0,
            transition: { 
                duration: 0.6,
                delay: i * 0.3,
                ease: "easeOut"
            }
        })
    }

    const imageVariants = {
        hidden: { scale: 0.95, opacity: 0.8 },
        visible: { 
            scale: 1, 
            opacity: 1,
            transition: { duration: 0.5 }
        },
        hover: { 
            scale: 1.03,
            transition: { duration: 0.3 }
        }
    }

    const textVariants = {
        hidden: { opacity: 0, x: -20 },
        visible: { 
            opacity: 1, 
            x: 0,
            transition: { duration: 0.5, delay: 0.2 }
        }
    }

    return (
        <div>
            <motion.div
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.2 }}
                variants={headingVariants}
            >
                <Heading className='bg-darkGreyPrimary py-4 sm:py-8 pt-8 sm:pt-12'
                    subTitle='The way we develop Enterprise applications'
                    text="We take a personalized approach to development, focusing on your organization's unique needs and collaborating with your team from the start to ongoing post-release support." />
            </motion.div>
            <div className='flex flex-col gap-6 sm:gap-12 pt-6 sm:pt-12 bg-darkGreyPrimary'>
                {enterpriseData.EnterPriseIdeaProjectsData.map((projects: any, index: number) => {
                     let img = getImage(projects.image ?? "") ?? "";
                    return (
                        <motion.div 
                            key={index}
                            custom={index}
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: true, amount: 0.1}}
                            variants={projectCardVariants}
                            className='bg-blackDark py-6 sm:py-12 border-b-4 border-[#313131] last:border-0'
                        >
                            <div className={`flex flex-col justify-center ${index % 2 !== 0 ? 'md:flex-row-reverse' : 'md:flex-row'} px-4 sm:px-40 gap-6 sm:gap-10`}>
                                <motion.div 
                                    className={`border-2 border-${projects.textColor} w-full sm:w-2/5 rounded-3xl overflow-hidden h-[450px]`}
                                    initial="hidden"
                                    whileInView="visible"
                                    whileHover="hover"
                                    variants={imageVariants}
                                >
                                    {/* <img src={projects.image} className="w-full h-full object-contain" alt={projects.title} /> */}
                                    <DynamicSVG color='#fff' size='w-full h-full'>{img}</DynamicSVG>
                                </motion.div>
                                <motion.div 
                                    className={classNames('flex flex-col w-full sm:w-4/12', `flex-${projects.row}`)}
                                    initial="hidden"
                                    whileInView="visible"
                                    variants={textVariants}
                                >
                                    <div className={classNames('font-semibold text-2xl sm:text-4xl', `text-${projects.textColor}`)} >{projects.title}</div>
                                    <div className={classNames('text-greyQuaternary text-base sm:text-lg pt-2 sm:pt-4', `text-${projects.text}`)}>{projects.subtitle}</div>
                                </motion.div>
                            </div>
                        </motion.div>
                    )
                })}
            </div>
        </div>
    )
}

export default EnterpriseIdeaProject
